import { useEffect, useState  } from "react";

export default function VideoEmbed({ url }) {
  // --------------------------
  // Détection plateformes
  // --------------------------
  const isYouTube = url?.includes("youtube.com") || url?.includes("youtu.be");
  const isTikTok = url?.includes("tiktok.com");
  const isFacebook = url?.includes("facebook.com") || url?.includes("fb.watch");

  // --------------------------
  // Hook TikTok embed.js → toujours appelé
  // --------------------------

  const [facebookError, setFacebookError] = useState(false)

  useEffect(() => {
    if (!isTikTok) return;

    if (!document.querySelector('script[src="https://www.tiktok.com/embed.js"]')) {
      const script = document.createElement("script");
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
    } else {
      window?.tiktokEmbed?.load && window.tiktokEmbed.load();
    }
  }, [isTikTok]);

  // --------------------------
  // Si pas d'URL, on ne rend rien
  // --------------------------
  if (!url) return null;

  // --------------------------
  // YouTube ID
  // --------------------------
  let youtubeId = null;
  if (isYouTube) {
    const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^#&?]{11})/);
    if (ytMatch) youtubeId = ytMatch[1];
  }

  // --------------------------
  // TikTok ID → accepte /video/ ou /photo/
  // --------------------------
  let tiktokId = null;
  let facebookEmbedUrl = null

  if (isFacebook) {
    facebookEmbedUrl =
    `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
      url
    )}&show_text=false&autoplay=true`
  }

  if (isTikTok) {
    const match = url.match(/\/(video|photo)\/(\d+)/);
    if (match) tiktokId = match[2]; // 2ème groupe = l'ID
  }

  // --------------------------
  // Styles responsive
  // --------------------------
  const containerStyle = {

    position: "relative",
    height: isTikTok || isFacebook
      ? "calc(100vh - 120px)"
      : "min(56.25vw, calc(100vh - 120px))",

    width: isTikTok || isFacebook
      ? "calc((100vh - 120px) * 0.5625)"
      : "100%",
    maxWidth: "1000px",
    margin: "0 auto",
    overflow: "hidden",
    borderRadius: "12px",
    background: "black",
  };
  const iframeStyle = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none",
  };

  // --------------------------
  // YouTube embed
  // --------------------------
  if (isYouTube && youtubeId) {
    return (
      <div style={containerStyle}>
        <iframe
          style={iframeStyle}
          src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube Video"
        />
      </div>
    );
  }

  // --------------------------
  // TikTok embed
  // --------------------------
  if (isTikTok && tiktokId) {
    return (
      <blockquote
        className="tiktok-embed"
        cite={url}
        data-video-id={tiktokId}
        style={{ maxWidth: "500px", margin: "0 auto" }}
      >
        <section></section>
      </blockquote>
    );
  }

  // --------------------------
  // Facebook embed
  // --------------------------

 if (isFacebook) {

    return (

      <div style={containerStyle}>

        <iframe  loading="lazy"
          style={iframeStyle}

          src={facebookEmbedUrl}

          title="Facebook Video"

          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"

          allowFullScreen
        />

      </div>
    )
  }

  // --------------------------
  // Fallback plateforme non supportée
  // --------------------------
  return <p>Plateforme non supportée : {url}</p>;
}
